
<template>
  <div id="page_referrals" class="column p0 minH100">
    <!-- ......................................... -->
    <div class="cointainer_xl column combo_1">
      <!-- ....... -->
      <div class="columns column">
        <div class="column page_landing_welcome_title is-three-fifths">
          <h1 class="component_title_lg fat m0_b">
            <div class="icon_class_1" v-html="iconSets.general_peers"></div>
            {{$tc("msg.referrals",1)}}
          </h1>
        </div>
        <!-- .. -->
      </div>
      <!-- ....... -->
      <div class="cointainer_sm combo_1">
        <div class="component_card">
          <div class="column">
            <h1
              class="tal_c text_lg fat component_card_border_bottom main_blue_dk_fill"
            >{{$tc("msg.earn_on_referrals",1)}}</h1>
            <!-- <p class="p">
              <strong>{{$t("msg.referral_text_1")}}</strong><br><br>
              <a href="/fees" class>{{$t("msg.view_reward_bonus_schedule")}}</a>
            </p> -->
            <div class="column" v-if="hasReferrals">
              <p class="p">
                {{$t("msg.referral_text_2")}}
              </p>
              <p class="p">
                <a :href="referralFullLink" class="dis_inb">{{referralFullLink}}</a>
                <button
                  class="main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper"
                  type="button"
                  v-clipboard:copy="referralFullLink"
                  v-clipboard:success="onCopySuccess"
                  v-clipboard:error="onCopyError"
                >{{$tc("msg.copy",1)}}</button>
              </p>
              <p class="p">
                {{$t("msg.referral_code")}}: {{member.referCode}}
                <button
                  class="main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper"
                  type="button"
                  v-clipboard:copy="member.referCode"
                  v-clipboard:success="onCopySuccess"
                  v-clipboard:error="onCopyError"
                >{{$tc("msg.copy",1)}}</button>
              </p>

              <div class="component_table" v-if="referrals">
                <vue-good-table
                  :columns="referralColumns"
                  :rows="referrals"
                  :sort-options="{
                        enabled: true,
                        initialSortBy: {field: 'createdAt', type: 'desc'}
                     }"
                  :pagination-options="{
                                        enabled: true,
                                        perPage: 10,
                                        position: 'bottom',
                                        perPageDropdown: [10,50,100],
                                        dropdownAllowAll: true,
                                        setCurrentPage: 1,
                                        nextLabel: $tc('msg.next',2),
                                        prevLabel: $tc('msg.previous',2),
                                        rowsPerPageLabel: $t('msg.rows_per_page'),
                                        ofLabel: $t('msg.of'),
                                        pageLabel: $t('msg.page'), // for 'pages' mode
                                        allLabel: $t('msg.all'),
                                      }"
                >
                <template slot="table-column" slot-scope="props">
                  <span v-if="props.column.label =='currencySymbol'">{{$t("msg.currency")}}</span>
                  <span v-if="props.column.label =='amount'">{{$t("msg.amount")}}</span>
                  <span v-if="props.column.label =='createdAt'">{{$t("msg.createdAt")}}</span>
                  <span v-if="props.column.label =='status'">{{$t("msg.status")}}</span>
                </template>
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'createdAt'">
                      <!-- {{fixTimeZone(props.formattedRow[props.column.field])}} -->

                      {{fixTimeTest(props.formattedRow[props.column.field])}}
                      <br>
                    </span>
                    <span v-else-if="props.column.field == 'amount'">
                      {{props.formattedRow[props.column.field].toFixed(6)}}
                    </span>
                    <span v-else-if="props.column.field == 'currencySymbol'">
                      BLUE
                    </span>
                    <span v-else-if="props.column.field == 'status'">
                      {{$t("msg.status_"+props.formattedRow[props.column.field])}}
                      <br>
                    </span>
                    <span v-else>{{props.formattedRow[props.column.field]}}</span>
                  </template>
                  <div slot="emptystate">
                    <base-loading v-if="loadingRewards" :text="'Loading rewards'"></base-loading>
                    <p class="tac" v-else>{{$tc("msg.no_data_found",1)}}</p>
                  </div>
                </vue-good-table>
              </div>

              <div class="column">
                <router-link
                  to="/transactions/deposits"
                  class="component_main_button main_blue_lt_bg main_blue_lt_bg_hover component_downloader_button combo_1 main_white_fill"
                >{{$t("msg.all_transactions")}}</router-link>
              </div>
            </div>

            <!-- .................................... -->
            <div class="column" v-else>
              <p class="p">
                {{$t("msg.referral_text_3")}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ......................................... -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import VueCsvDownloader from "vue-csv-downloader";
import BaseLoading from "../../components/public/BaseLoading";

export default {
  created() {
    this.getReferrals();
  },
  mounted() {
       this.getReferrals();
  },
  data: () => ({
    loadingRewards: false,
    hasReferrals: true,
    referralURI: "/app/referralcode=",
    referralColumns: [
       {
        label: "createdAt",
        field: "createdAt",
        sortable: true,
      },
      // {
      //   label: "updatedAt",
      //   field: "updatedAt",
      //   sortable: true,
      // },
      {
        label: "amount",
        field: "amount"
      },
      {
        label: "currencySymbol",
        field: "currencySymbol"
      },
      {
        label: "status",
        field: "status"
      }
    ],
    referrals: false,
  }),
  components: {
    VueCsvDownloader,
    BaseLoading
  },
  methods: {
    async getReferrals() {
      this.loadingRewards = true;
      try {
        let resp = await this.$store.dispatch(
          "getTransactionsByType",
          "reward"
        );
        this.referrals = resp.data;
        this.loadingRewards = false;
        // console.log(this.referrals);
      } catch (e) {
        this.logError(e);
        this.loadingRewards = false;
      }
    },

    simbAjust(el){
      if(el == 'BLU'){
        return 'BLUE'
      }else{
        return el;
      }
    }
  },
  computed: {
    ...mapGetters(["member"]),
    referralFullLink() {
      return window.location.origin + this.referralURI + this.member.referCode;
    }
  },
  watch: {}
};
</script>
<style lang="css">
.component_main_button {
  padding: 9px 16px;
  min-width: 82px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/Referrals.vue